var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.fields)?_c('div',{staticClass:"separator-wrapper",class:_vm.data.fields.mobileDesktop},[_c('div',{staticClass:"separator"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }